module.exports = __webpack_public_path__ + "img/volvo.be25dd11.svg";